import { render, staticRenderFns } from "./groupPopup.vue?vue&type=template&id=06417907&scoped=true"
import script from "./groupPopup.vue?vue&type=script&lang=ts"
export * from "./groupPopup.vue?vue&type=script&lang=ts"
import style0 from "./groupPopup.vue?vue&type=style&index=0&id=06417907&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06417907",
  null
  
)

export default component.exports